export function encodeRoomPacket(value: unknown): string {
  return JSON.stringify(value, (_key, item: unknown) =>
    typeof item === "bigint" ? { $kilnfrontBigInt: item.toString() } : item,
  );
}

export function decodeRoomPacket<T>(value: string): T {
  return JSON.parse(value, (_key, item: unknown) => {
    if (
      item &&
      typeof item === "object" &&
      !Array.isArray(item) &&
      Object.keys(item).length === 1 &&
      typeof (item as Record<string, unknown>).$kilnfrontBigInt === "string"
    )
      return BigInt((item as Record<string, string>).$kilnfrontBigInt ?? "0");
    return item;
  }) as T;
}

export function decodeBoundedRoomPacket<T>(value: string, maximumBytes = ROOM_PACKET_MAX_BYTES): T {
  if (new TextEncoder().encode(value).byteLength > maximumBytes)
    throw new RangeError("Room packet exceeds the byte limit");
  return decodeRoomPacket<T>(value);
}
export const ROOM_PACKET_MAX_BYTES = 65_536;
